import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Notification } from '../../../../common/notification'
import { Table } from '../../../../common/table'
import { PERIOD } from '../../../common/constant'
import { selectPeriod } from '../../../common/period/slice'
import { VALUE_SCORE } from '../../constant'
import { selectScoreActive } from '../../store/slice'
import { SelectSearch } from '../common/SelectSearch'
import { IDS_TREND_BY_PORT } from '../constant'
import { handleGetIdsCheckDynamic } from '../helper'
import {
  getDataReduxTable,
  getDataReduxTablePer,
  selectActivePortfolio,
  selectColumnTable,
  selectColumnTablePer,
} from '../store/slice'
import { CellData } from './CellData'
import { NamePort } from './NamePort'

export const TableTrendPort = ({
  isDynamicReport,
  portfolio1,
  portfolio2,
  checkTypePort,
  type,
}) => {
  const columnTableRisk = useSelector(selectColumnTable)
  const columnTablePer = useSelector(selectColumnTablePer)
  const period = useSelector(selectPeriod)
  const activePortfolio2 = useSelector(
    selectActivePortfolio('activePortfolio2'),
  )
  const activePortfolio1 = useSelector(
    selectActivePortfolio('activePortfolio1'),
  )
  const { value: typeValueStore } = useSelector(selectScoreActive)

  const typeValue = isDynamicReport ? type : typeValueStore
  const columnTable =
    typeValue === VALUE_SCORE.CREDIT_SCORE ? columnTableRisk : columnTablePer

  const schema = columnTable.map((item) => {
    const colId = item
    const title =
      item === 'name' ? <Translate value="portfolio.summary.PORTFOLIO" /> : item

    return {
      colId,
      title,
      thStyle:
        colId === 'name'
          ? { minWidth: 200 }
          : { justifyContent: 'center', textAlign: 'center' },
      tdStyle:
        colId === 'name'
          ? {}
          : { justifyContent: 'center', textAlign: 'center' },
      render: (data, { rowId }) => {
        switch (colId) {
          case 'name':
            if (rowId === IDS_TREND_BY_PORT.PORTFOLIO_FIRST) {
              if (isDynamicReport) {
                return <div className="fw600">{portfolio1?.namePortfolio}</div>
              }
              return (
                <SelectSearch
                  activePortfolio={activePortfolio1}
                  keyPort="activePortfolio1"
                />
              )
            }
            if (rowId === IDS_TREND_BY_PORT.PORTFOLIO_SECOND) {
              if (isDynamicReport) {
                return <div className="fw600">{portfolio2?.namePortfolio}</div>
              }
              return (
                <SelectSearch
                  activePortfolio={activePortfolio2}
                  keyPort="activePortfolio2"
                />
              )
            }
            return (
              <NamePort
                data={data}
                rowId={rowId}
                isDynamicReport={isDynamicReport}
                typeValue={typeValue}
              />
            )

          default:
            return (
              <CellData
                data={data}
                isDynamicReport={isDynamicReport}
                typeValue={typeValue}
              />
            )
        }
      },
    }
  })

  if (isDynamicReport && !Object.values(IDS_TREND_BY_PORT).length)
    return <Notification isDynamicReport />

  return (
    <Table
      ids={
        isDynamicReport
          ? handleGetIdsCheckDynamic(portfolio1, portfolio2, checkTypePort)
          : Object.values(IDS_TREND_BY_PORT)
      }
      schema={schema}
      getDataFromRedux={
        typeValue === VALUE_SCORE.CREDIT_SCORE
          ? getDataReduxTable
          : getDataReduxTablePer
      }
      isStickyFirstCol={period !== PERIOD.YEAR.value}
      autoHeightMax={600}
      defaultScrollToRight
    />
  )
}

TableTrendPort.propTypes = {
  isDynamicReport: PropTypes.bool,
  portfolio1: PropTypes.object,
  portfolio2: PropTypes.object,
  checkTypePort: PropTypes.array,
  timePeriod: PropTypes.string,
}

TableTrendPort.defaultProps = {
  isDynamicReport: false,
  portfolio1: {},
  portfolio2: {},
  checkTypePort: [],
  timePeriod: 'Yearly',
}
